import { makeLabels } from 'utils/i18n';

const NAMESPACE = 'page.merchant.accountSettings.payoutReserve';
export const LABELS = makeLabels(
  {
    PAGE_TITLE: ['pageTitle', 'Payout Reserve'],
    PAYOUT_RESERVE_BALANCE: ['refundWalletBalance', 'Payout Reserve Balance:'],
  },
  NAMESPACE,
);
